const subscribers = [];

const createGlobalEventBus = () => {
  window.addEventListener("event-bus", eventRouter);
};

const eventRouter = ({ detail: { type, payload, onReturn } }) => {
  subscribers
    .filter((sub) => sub.type === type)
    .forEach((sub) => {
      let result = sub.cb(payload);
      if (onReturn) {
        onReturn(result);
      }
    });
};

const subscribe = (type, cb) => {
  let subscriber = { type: type, cb: cb };
  subscribers.push(subscriber);
  return subscriber;
};

const unsubscribe = (subscriber) => {
  let index = subscribers.indexOf(subscriber);
  if (index > -1) {
    subscribers.splice(index, 1);
  }
};

const publish = (message) => {
  window.dispatchEvent(new CustomEvent("event-bus", { detail: message }));
};

export { publish, subscribe, unsubscribe, createGlobalEventBus };
